export default __webpack_public_path__ + "static/media/menu-help-icon.ba608485.svg";